import { Map, Wind, Flame, Snowflake, Zap, FlaskConical, Users, Settings, FileSearch, Headphones } from "lucide-react";
import { Link } from "react-router";

export function Sitemap() {
    const sections = [
        {
            title: "Main Pages",
            links: [
                { label: "Home", path: "/" },
                { label: "About Us", path: "/about", icon: Users },
                { label: "Our Services", path: "/services", icon: Settings },
                { label: "Products", path: "/products" },
                { label: "Blog", path: "/blog", icon: FileSearch },
                { label: "Contact Us", path: "/contact", icon: Headphones },
            ]
        },
        {
            title: "Services & Products",
            links: [
                { label: "HVAC Projects", path: "/services/hvac", icon: Wind },
                { label: "Heat Pump Water Heater", path: "/services/heat-pump", icon: Flame },
                { label: "Refrigeration & Cold Room", path: "/services/refrigeration", icon: Snowflake },
                { label: "Electrical Panel & PLC", path: "/services/electrical", icon: Zap },
                { label: "Refrigerant ISO Tank System", path: "/services/refrigerant", icon: FlaskConical },
            ]
        },
        {
            title: "Legal",
            links: [
                { label: "Privacy Policy", path: "/privacy-policy" },
                { label: "Terms & Conditions", path: "/terms" },
                { label: "Sitemap", path: "/sitemap" },
            ]
        }
    ];

    return (
        <div className="max-w-4xl mx-auto px-6 py-12">
            <Link to="/" className="text-[#E9A319] hover:underline mb-8 inline-block text-sm font-semibold">&larr; Back to Home</Link>
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12">
                <div className="flex items-center gap-4 mb-10 pb-8 border-b border-gray-100">
                    <div className="w-14 h-14 bg-blue-50 text-[#1a2d50] rounded-xl flex items-center justify-center shrink-0">
                        <Map className="w-7 h-7" />
                    </div>
                    <div>
                        <h1 className="text-3xl md:text-4xl text-[#1a2d50]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800 }}>Sitemap</h1>
                        <p className="text-muted-foreground mt-1">Navigate our website</p>
                    </div>
                </div>

                <div className="grid md:grid-cols-2 gap-12">
                    {sections.map((section) => (
                        <div key={section.title}>
                            <h2 className="text-xl text-[#1a2d50] mb-6 pb-2 border-b border-gray-100" style={{ fontWeight: 700 }}>
                                {section.title}
                            </h2>
                            <ul className="space-y-4">
                                {section.links.map((link) => (
                                    <li key={link.path}>
                                        <Link
                                            to={link.path}
                                            className="group flex items-center gap-3 text-gray-600 hover:text-[#E9A319] transition-colors"
                                        >
                                            <div className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center group-hover:bg-[#E9A319]/10 transition-colors shrink-0">
                                                {link.icon ? (
                                                    <link.icon className="w-4 h-4" />
                                                ) : (
                                                    <div className="w-1.5 h-1.5 rounded-full bg-gray-300 group-hover:bg-[#E9A319]" />
                                                )}
                                            </div>
                                            <span className="font-medium">{link.label}</span>
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
